import styled from 'styled-components';
import {
  MARGIN,
  BREAKPOINT,
  REBRAND_COLOR,
  REBRAND_GRADIENT,
  PADDING
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const StyledHeroContainer = styled.div`
  margin-top: ${({ marginTopMobile }) =>
      marginTopMobile ? marginTopMobile : '0px'};
  background:  ${({ background }) =>
      background ? background : `${REBRAND_COLOR.STONE}`};
  @media (min-width: ${BREAKPOINT.LG}) {
    margin-top: ${({ marginTop }) =>
      marginTop ? `${marginTop}` : '0px'};
  }
`;

export const StyledHeroSection = styled.div`
  background: ${REBRAND_GRADIENT.SKYWARD_BLUE};
  border-radius: 0 0 0 64px;
  .slick-slide {
    padding: ${({ slides }) =>
      slides?.length > 1 ? `0px 0px ${PADDING.P64} 0;` : '0px'};
    @media (min-width: ${BREAKPOINT.LG}) {
      padding: ${({ slides }) =>
        slides?.length > 1 ? `0px 0px ${PADDING.P80} 0;` : '0px'};
    }
  }

  .slick-dots {
    position: absolute;
    bottom: 64px;
    left: 20px;
    @media (min-width: ${BREAKPOINT.MD}) {
      left: 40px;
    }
    @media (min-width: 1600px) {
      left: calc((100vw - 1400px) / 2);
    }
    display: flex !important;
  }

  .slick-dots li {
    width: 15px;
  }

  .slick-dots li.slick-active {
    margin-right: ${MARGIN.M16};
  }

  .slick-dots li button {
    width: 12px;
    height: 12px;
    padding: 0;
  }

  .slick-dots li button::before {
    content: '';
    display: block;
    position: static;
    font-size: 0;
    line-height: 0;

    width: 12px;
    height: 12px;
    background-color: ${REBRAND_COLOR.STONE};
    border-radius: 50%;
    opacity: 1;
  }

  .slick-dots li.slick-active button::before {
    width: 24px;
    background-color: ${REBRAND_COLOR.GREEN};
    border-radius: 32px;
  }
`;

export const StyledHeaderSection = styled(Section)`
  padding-top: ${PADDING.P64};
  padding-bottom: ${PADDING.P32};
  display: block !important;
  @media (min-width: ${BREAKPOINT.MD}) {
    padding-top: ${PADDING.P64};
    padding-bottom: ${PADDING.P64};
  }
  .slick-slide {
    padding: 0px;
  }
`;

export const StyledGrid = styled.div`
  display: flex;
  flex-direction: ${({ isMobileReversed }) =>
    isMobileReversed ? 'column-reverse' : 'column'};
  gap: ${({ isMobileReversed }) => (isMobileReversed ? '2.5rem' : '0')};
  align-items: center;

  @media (min-width: ${BREAKPOINT.LG}) {
    flex-direction: row;
    gap: 3rem;
  }
`;

export const StyledTextContainer = styled.div`
  text-align: left;
  padding: 0;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ slides, isMobileReversed }) =>
    slides?.length > 1 && isMobileReversed ? `${MARGIN.M40}` : `0`};
  gap: 16px;
  @media (min-width: ${BREAKPOINT.LG}) {
    gap: 24px;
    margin-bottom: 0;
  }
`;

export const StyledImageContainer = styled.div`
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  margin: ${({ slides, isMobileReversed }) =>
    slides?.length > 1 && !isMobileReversed ? `${MARGIN.M40} 0` : `0`};
  @media (min-width: ${BREAKPOINT.LG}) {
    margin: 0;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
`;

export const StyledButtonWrapper = styled.div``;

export const StyledHeading = styled.div``;

export const StyledSubeading = styled.div``;

export const StyledDisclaimer = styled.div`
  margin-top: 8px;
  @media (min-width: ${BREAKPOINT.LG}) {
    margin-top: 0px;
  }
`;
